export default function toArray(enumerable) {
    return [...enumerable];
}
